module.exports = __webpack_public_path__ + "img/contratos.23724eb5.gif";